import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../box/src";
export const ProgressBar = ({ percentWidth, text }) => (_jsxs(Box, { "data-testid": "ds-m-progress-bar", display: "block", children: [_jsx(StyledProgressBarWrapper, { "data-testid": "ds-m-progress-bar-wrapper", children: _jsx(StyledProgressBar, { "$percentWidth": percentWidth, "data-testid": "ds-m-progress-bar-primary" }) }), text && (_jsx(Box, { color: "primary", mt: 2, children: text }))] }));
const StyledProgressBarWrapper = styled(Box).attrs(() => ({
    bg: 'primaryLighter',
    height: '9px',
    width: '100%',
})) `
  border-radius: 5px;
  clip-path: inset(0 0 0 0 round 5px);
`;
const StyledProgressBar = styled(Box).attrs(({ $percentWidth }) => ({
    bg: 'primary',
    height: '100%',
    width: `${$percentWidth}%`,
})) `
  border-radius: 5px;
  z-index: 2;
`;
//# sourceMappingURL=ProgressBar.js.map